/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AvatarSourceEnum } from './AvatarSourceEnum';
import {
    AvatarSourceEnumFromJSON,
    AvatarSourceEnumFromJSONTyped,
    AvatarSourceEnumToJSON,
} from './AvatarSourceEnum';

/**
 * 
 * @export
 * @interface UserListItemDTO
 */
export interface UserListItemDTO {
    /**
     * 
     * @type {string}
     * @memberof UserListItemDTO
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof UserListItemDTO
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserListItemDTO
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserListItemDTO
     */
    avatarUrl: string;
    /**
     * 
     * @type {AvatarSourceEnum}
     * @memberof UserListItemDTO
     */
    avatarSource: AvatarSourceEnum;
}



/**
 * Check if a given object implements the UserListItemDTO interface.
 */
export function instanceOfUserListItemDTO(value: object): value is UserListItemDTO {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    if (!('avatarSource' in value) || value['avatarSource'] === undefined) return false;
    return true;
}

export function UserListItemDTOFromJSON(json: any): UserListItemDTO {
    return UserListItemDTOFromJSONTyped(json, false);
}

export function UserListItemDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserListItemDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'avatarUrl': json['avatarUrl'],
        'avatarSource': AvatarSourceEnumFromJSON(json['avatarSource']),
    };
}

export function UserListItemDTOToJSON(value?: UserListItemDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'username': value['username'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'avatarUrl': value['avatarUrl'],
        'avatarSource': AvatarSourceEnumToJSON(value['avatarSource']),
    };
}

